let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("76xTz")).then(() => parcelRequire('3Y0kU'));